import { memo } from "react";

import { AppSEO } from "@hl/shared-features/lib/features/layout/AppSEO";
import { Container, Title } from "@mantine/core";

import * as styles from "./styles";

const FeatureNotAvailable = () => (
  <>
    <AppSEO title="Page not found" />

    <Container size="md">
      <div css={styles.content}>
        <Title size="large" mb={32}>
          This Page Is Temporarily Not Available
        </Title>
      </div>
    </Container>
  </>
);

export default memo(FeatureNotAvailable);
